import { useEffect } from "react";
import "@/App.css";
import Lenis from "@studio-freight/lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { VideoShowcase } from "@/components/VideoShowcase";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { WhatsAppFAB } from "@/components/WhatsAppFAB";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App gd-noise">
      <Navbar />
      <main>
        <Hero />
        <Manifesto />
        <Services />
        <Gallery />
        <VideoShowcase />
        <Testimonials />
        <Contact />
      </main>
      <WhatsAppFAB />
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
